export const NavbarHeight = '70px';
